import { Button } from '@/components/ui/button';
import { useOktaAuth } from '@okta/okta-react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/')({
  // We will handle logic in the component based on authState
  component: HomeComponent,
});

function HomeComponent() {
  const { oktaAuth, authState } = useOktaAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authState?.isAuthenticated) {
      navigate({ to: '/search', replace: true });
    }
  }, [authState, navigate]);

  const login = async () =>
    oktaAuth.signInWithRedirect({ originalUri: '/search' });

  if (authState?.isPending || authState?.isAuthenticated) {
    // If pending or already authenticated (and useEffect will redirect soon)
    return (
      <div aria-live='polite' aria-atomic='true'>
        Loading or redirecting...
      </div>
    );
  }

  // If not authenticated and not pending, show login prompt.
  return (
    <div className='p-4 text-center'>
      <h1 className='text-2xl font-semibold mb-4'>
        Total Care Auto Powered by Asbury
        <br />
        Lender Quote Portal
      </h1>
      <p className='mb-6'>
        Login to search for contracts and request cancellation quotes.
      </p>
      <Button variant='default' onClick={login}>
        Login
      </Button>
    </div>
  );
}
